import axios, { AxiosInstance } from 'axios';

import { Configuration } from 'src/Services/API/generated';
import {
  UpdateGovernanceDto,
  UpdateMemberGovernanceDto,
  UpdateOwnerGovernanceDto,
} from 'src/types/governance.types';

export class GovernanceApi {
  private axiosInstance: AxiosInstance;

  constructor(configuration: Configuration) {
    this.axiosInstance = axios.create({
      baseURL: configuration.basePath || '',
      ...configuration.baseOptions,
    });
  }

  async updateAssetGovernance(assetId: string, data: UpdateGovernanceDto): Promise<void> {
    await this.axiosInstance.patch(`/assets/${assetId}/governance`, data);
  }

  async updateMemberGovernance(
    assetId: string,
    membershipId: string,
    data: UpdateMemberGovernanceDto
  ): Promise<void> {
    await this.axiosInstance.patch(`/assets/${assetId}/members/${membershipId}/governance`, data);
  }

  async updateOwnerGovernance(assetId: string, data: UpdateOwnerGovernanceDto): Promise<void> {
    await this.axiosInstance.patch(`/assets/${assetId}/governance/owner`, data);
  }
}
